export enum Role {
  INSIGHTFUL = 'insightful user',
  INSIGHTFUL_ADMIN = 'insightful admin user',
  KUMANU_INSIGHTFUL_ADMIN = 'kumanu insightful user',
  PURPOSEFUL = 'purposeful user',
  PUBLIC = 'public user',
  RESOURCEFUL = 'resourceful user',
}
